import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const WarningBanner = styled.div`
  width: 100%;
  background-color: ${(p) => p.theme.toast.warning};
  color: ${(p) => p.theme.color.palette.almostBlack};
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
`;

export const TabContentContainer = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;
`;

export const OverlayRoot = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  pointer-events: none;
`;
